import React from "react";

export const NoMatch = () => {
  return <div>NoMatch</div>;
};
